import React from "react";
import Title from "../../Dashboard/Title";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Box } from "@mui/system";
import { useLocation, useSearchParams } from "react-router-dom";
import ResultSummary from "./ResultSummary";
import DownloadResult from "./DownloadResult";
import ResultTermPeriod from "./ResultTermPeriod";

const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#671E78",
    },
  },
});
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const Result = () => {
  const location = useLocation();
  const tab_id = Number(new URLSearchParams(location.search).get("tab")) || 0;
  const page_id = Number(new URLSearchParams(location.search).get("page")) || 1;
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChange = (event, newValue) => {
    setSearchParams({ ...searchParams, tab: newValue, page: page_id });
  };
  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <Box>
          <Title title="Result" showCaption={false} />

          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tab_id}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Result Summary"
                  {...a11yProps(0)}
                  sx={{
                    textTransform: "initial",
                    fontFamily: "Gilroy-Bold",
                    fontSize: "18px",
                  }}
                />
                <Tab
                  // New Staffs
                  label="Term Period Summary"
                  {...a11yProps(1)}
                  sx={{
                    textTransform: "initial",
                    fontFamily: "Gilroy-Bold",
                    fontSize: "18px",
                  }}
                />

                                <Tab
                  // New Staffs
                  label="Download Results"
                  {...a11yProps(2)}
                  sx={{
                    textTransform: "initial",
                    fontFamily: "Gilroy-Bold",
                    fontSize: "18px",
                  }}
                />
              </Tabs>
            </Box>
            {tab_id === 0 && <ResultSummary />}

            {tab_id === 1 && <ResultTermPeriod />}

            {tab_id === 2 && <DownloadResult />}
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
};

export default Result;
